export enum InternalDepartmentTypeEnum {
	Internment = "Internamento",
	RedRoom = "Sala Vermelha",
	Observation = "Observação",
}
